<template>
  <div :id="content.id" class="text-center py-12 section-title">
    <h2 class="text-gray-600 text-3xl md:text-5xl font-medium" v-html="content.title"></h2>
    <p class="md:mt-3 mt-2 md:text-lg text-base text-gray-500 font-medium" v-if="content.subtitle" v-html="content.subtitle"></p>
    <div style="height:2px" class="w-10 mx-auto md:mt-5 mt-2 bg-primary"></div>
  </div>
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    content: {
      type: Object,
    },
  },
};
</script>

<style scoped>
</style>
